import { Navigate, Route, Routes } from 'react-router-dom';

import { AuthLayout } from 'modules/auth/components';
import { CreatePasswordPage } from 'modules/auth/pages/CreatePassword';
import { ForgotPasswordPage } from 'modules/auth/pages/ForgotPassword';
import LoginPage from 'modules/auth/pages/Login';
import { VerifyEmailPage } from 'modules/auth/pages/VerifyEmail';

import { includes } from 'lodash';

import { ListAuthPath, PATH } from 'constants/path';

const PublicRoutes = () => {
  const isNotAuthPath = !includes(ListAuthPath, location.pathname);

  return (
    <Routes>
      <Route element={<AuthLayout />}>
        <Route path={PATH.LOGIN} element={<LoginPage />} />{' '}
        <Route path={PATH.FORGOT_PASSWORD} element={<ForgotPasswordPage />} />
        <Route path={PATH.RESET_PASSWORD} element={<CreatePasswordPage />} />
        <Route path={PATH.VERIFY_EMAIL} element={<VerifyEmailPage />} />
        <Route index path="/" element={<Navigate to={PATH.LOGIN} />} />
        <Route path="*" element={<Navigate to={isNotAuthPath ? PATH.LOGIN : PATH.ERROR_404} />} />
      </Route>
    </Routes>
  );
};

export { PublicRoutes };
